import React, { useContext } from 'react';
import { Menu, MenuItem, Sidebar } from 'react-pro-sidebar';
import { Book, Bookmark, List, PersonFill } from 'react-bootstrap-icons';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import logo from '../images/Inkitlogo.png';
import { useUser } from '../components/UserContext';
import { useToken } from '../components/TokenProvider';
import { ThemeContext, ThemeProvider } from '../utils/theme-context/ThemeContext';
import { ConfigProvider } from 'antd';
import { getTheme } from '../utils/theme-context/customtheme';


const themes = {
  light: {
    sidebar: {
      backgroundColor: '#ffffff',
      color: '#607489',
    },
    menu: {
      menuContent: '#fbfcfd',
      icon: '#00aca5',
      hover: {
        backgroundColor: '#ddf1ef',
        color: '#44596e',
      },
      disabled: {
        color: '#9fb6cf',
      },
    },
  },
  dark: {
    sidebar: {
      backgroundColor: '#0b2948',
      color: '#8ba1b7',
    },
    menu: {
      menuContent: '#082440',
      icon: '#59d0ff',
      hover: {
        backgroundColor: '#00458b',
        color: '#b6c8d9',
      },
      disabled: {
        color: '#3e5e7e',
      },
    },
  },
};

const menuClasses = {
  root: 'ps-menu-root',
  menuItemRoot: 'ps-menuitem-root',
  subMenuRoot: 'ps-submenu-root',
  button: 'ps-menu-button',
  prefix: 'ps-menu-prefix',
  suffix: 'ps-menu-suffix',
  label: 'ps-menu-label',
  icon: 'ps-menu-icon',
  subMenuContent: 'ps-submenu-content',
  SubMenuExpandIcon: 'ps-submenu-expand-icon',
  disabled: 'ps-disabled',
  active: 'ps-active',
  open: 'ps-open',
};

// hex to rgba converter
const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const AdminLayout = () => {
  const [collapsed, setCollapsed] = React.useState(false);
  const [toggled, setToggled] = React.useState(false);
  const [broken, setBroken] = React.useState(false);
  const [rtl, setRtl] = React.useState(false);
  const [hasImage, setHasImage] = React.useState(false);
  const { user, setUser } = useUser();
  const { clearToken } = useToken(); // Access the token from context
  const navigate = useNavigate();
  const user_data = user?.user_data ?? {};
  const { theme } = useContext(ThemeContext);
  const themeMode = getTheme(theme);

  const menuItemStyles = {
    root: {
      fontSize: '16px',
      fontWeight: 400,
    },
    icon: {
      color: themes[theme].menu.icon,
      [`&.${menuClasses.disabled}`]: {
        color: themes[theme].menu.disabled.color,
      },
    },
    SubMenuExpandIcon: {
      color: '#b6b7b9',
    },
    subMenuContent: ({ level }) => ({
      backgroundColor:
        level === 0
          ? hexToRgba(themes[theme].menu.menuContent, hasImage && !collapsed ? 0.4 : 1)
          : 'transparent',
    }),
    button: {
      [`&.${menuClasses.disabled}`]: {
        color: themes[theme].menu.disabled.color,
      },
      color: '#44596e',
      '&:hover': {
        backgroundColor: hexToRgba(themes[theme].menu.hover.backgroundColor, hasImage ? 0.8 : 1),
        color: themes[theme].menu.hover.color,
      },
    },
    label: ({ open }) => ({
      fontWeight: open ? 600 : undefined,
    }),
  };


  const handleLogout = () => {
    clearToken();
    setUser({});
    navigate("/admin/login");
  };

console.log("themeMode", themeMode);

  return (
    <ConfigProvider
      theme={{
        token: {
          ...themeMode
        },
      }}
    >
      <div style={{ display: 'flex', height: '100vh', direction: rtl ? 'rtl' : 'ltr' }}>
        <Sidebar
          collapsed={collapsed}
          toggled={toggled}
          onBackdropClick={() => setToggled(false)}
          onBreakPoint={setBroken}
          image="https://user-images.githubusercontent.com/25878302/144499035-2911184c-76d3-4611-86e7-bc4e8ff84ff5.jpg"
          rtl={rtl}
          breakPoint="md"
          backgroundColor={hexToRgba(themes[theme].sidebar.backgroundColor, hasImage ? 0.9 : 1)}
          rootStyles={{
            color: themes[theme].sidebar.color,
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div className="admin-logo">
              <img src={logo} alt="logo" />
              <p className={`${collapsed ? 'd-none' : 'd-block'}`} variant="subtitle1" fontWeight={700} color="#0098e5">
                INK IT SOLUTIONS
              </p>
            </div>
            <div style={{ flex: 1, marginBottom: '32px' }}>
              {/* <div style={{ padding: '0 24px', marginBottom: '8px' }}>
              <p
                variant="body2"
                fontWeight={600}
                style={{ opacity: collapsed ? 0 : 0.7, letterSpacing: '0.5px' }}
              >
                General
              </p>
            </div> */}
              {/* <Menu menuItemStyles={menuItemStyles}>
              <SubMenu
                label="Charts"
                icon={<BarChartFill />}
                suffix={
                  <Badge3d variant="danger" shape="circle">
                    6
                  </Badge3d>
                }
              >
                <MenuItem> Pie charts</MenuItem>
                <MenuItem> Line charts</MenuItem>
                <MenuItem> Bar charts</MenuItem>
              </SubMenu>
              <SubMenu label="Maps" icon={<GlobeCentralSouthAsia />}>
                <MenuItem> Google maps</MenuItem>
                <MenuItem> Open street maps</MenuItem>
              </SubMenu>
              <SubMenu label="Theme" icon={<BodyText />}>
                <MenuItem> Dark</MenuItem>
                <MenuItem> Light</MenuItem>
              </SubMenu>
              <SubMenu label="Components" icon={<DiamondFill />}>
                <MenuItem> Grid</MenuItem>
                <MenuItem> Layout</MenuItem>
                <SubMenu label="Forms">
                  <MenuItem> Input</MenuItem>
                  <MenuItem> Select</MenuItem>
                  <SubMenu label="More">
                    <MenuItem> CheckBox</MenuItem>
                    <MenuItem> Radio</MenuItem>
                  </SubMenu>
                </SubMenu>
              </SubMenu>
              <SubMenu label="E-commerce" icon={<Cart />}>
                <MenuItem> Product</MenuItem>
                <MenuItem> Orders</MenuItem>
                <MenuItem> Credit card</MenuItem>
              </SubMenu>
            </Menu> */}

              {/* <div style={{ padding: '0 24px', marginBottom: '8px', marginTop: '32px' }}>
              <p
                variant="body2"
                fontWeight={600}
                style={{ opacity: collapsed ? 0 : 0.7, letterSpacing: '0.5px' }}
              >
                Extra
              </p>
            </div> */}

              <Menu menuItemStyles={menuItemStyles}>
                {/* <MenuItem icon={<Calendar />} suffix={<Badge3d variant="success">New</Badge3d>}>
                Calendar
              </MenuItem> */}
                <Link to="/admin/assessments" className="text-decoration-none w-100 d-block">
                  <MenuItem icon={<Book />}>
                    Assessment
                  </MenuItem>
                </Link>
                <Link to="/admin/attempts" className="text-decoration-none w-100 d-block">
                  <MenuItem icon={<Bookmark />}>
                    Attempts
                  </MenuItem>
                </Link>
                {/* <MenuItem disabled icon={<Gear />}>
                Examples
              </MenuItem> */}
              </Menu>
            </div>
          </div>
        </Sidebar>

        <main style={{
          flex: 1, padding: "10px", height: "100vh",
          overflow: "auto",
          overflowX: "hidden",
          position: "relative"
        }}>

          {/* <div style={{ marginBottom: '16px' }}>
            {broken && (
              <button className="sb-button" onClick={() => setToggled(!toggled)}>
                Toggle
              </button>
            )}
          </div>
          <div style={{ marginBottom: '48px' }}>
            <p variant="h4" fontWeight={600}>
              React Pro Sidebar
            </p>
            <p variant="body2">
              React Pro Sidebar provides a set of components for creating high level and
              customizable side navigation
            </p>
          </div>

          <div style={{ padding: '0 8px' }}>
            <div style={{ marginBottom: 16 }}>
              <div class="form-check form-switch">
                <input
                  checked={collapsed}
                  onChange={() => setCollapsed(!collapsed)}
                  label="Collapse" class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" />
                <label class="form-check-label" for="flexSwitchCheckChecked">Checked switch checkbox input</label>
              </div>
            </div>
          </div> */}

          <div className="d-flex justify-content-between top-header mb-3">
            <div className="left-header">
              <List size={24} onClick={() => broken ? setToggled(!toggled) : setCollapsed(!collapsed)} />
            </div>
            <div className="right-header-icon ml-auto d-flex align-items-center justify-content-end gap-2">

              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic" className="profile-user">

                  {/* <img src="https://propchainbucket.s3.amazonaws.com/dp/288e6fc5-d709-4fbb-ba19-9459803153a3.jpg" alt="logo" /> */}
                  <PersonFill size={24} />

                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item disabled>{(user_data?.first_name || 'Admin') + " " + (user_data?.last_name || 'Admin')}</Dropdown.Item>
                  {/* <Dropdown.Item href="#/action-2">Profile</Dropdown.Item> */}
                  <Dropdown.Item onClick={handleLogout}>Log Out</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <Outlet />
        </main>
      </div>
    </ConfigProvider>
  );
};

// Wrap the App component with ThemeProvider to provide the context
const AppWrapper = () => (
  <ThemeProvider>
      <AdminLayout />
  </ThemeProvider>
);

export default AppWrapper;